import { useCallback, useEffect, useRef } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGenerateInterviewQuestions,
  useScheduleInterview,
  useCheckCandidateEmail,
} from "../../../../store/query/scheduleInterviewQuery";
import { useAllUserList, useMe } from "../../../../store/query/userQuery";
import { useGetAllRoles } from "../../../../store/query/roleQuery";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { JobEndPoint, SavedCandidateEndPoint } from "../../../../api-routes";
import { debounce } from "lodash";
import { useFormik } from "formik";
import { isValidPhoneNumber } from "libphonenumber-js";
import * as Yup from "yup";
import { LANGUAGE_OPTIONS } from "../../../../constants/languages";
const useInterviewScheduling = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const prefillData = location.state || {};
  const [onChangeValidation, setOnChangeValidation] = useState(false);
  const [profilePic, setProfilePic] = useState("");
  const interviewScheduleMutation = useScheduleInterview();
  const checkCandidateEmailMutation = useCheckCandidateEmail();
  const generateInterviewQuestionsMutation = useGenerateInterviewQuestions();
  const loginUserDetail = useMe();
  const allRoles = useGetAllRoles();
  const [startDate, setStartDate] = useState(null);
  const [clearFile, setClearFile] = useState(false);
  const fileRef = useRef(null);
  const fileRef1 = useRef(null);
  const [clearProfilePic, setClearProfilePic] = useState(false);
  const [validPhoneNumber, setValidPhoneNumber] = useState(false);
  const [phomeErrorMessage, setPhomeErrorMessage] = useState(null);
  const [loginUserRoles, setLoginUserRole] = useState(null);
  const [recruiter, setRecruiter] = useState(null);
  const [source, setSource] = useState(null);
  const [allRecruiterList, setAllRecruiterList] = useState([]);
  const [allSourceList, setAllSourceList] = useState([]);

  const [filterOptions, setFilterOptions] = useState({
    page: 1,
    limit: 10,
    name: "",
  });
  const [sourceFilterOptions, setSourceFilterOptions] = useState({
    page: 1,
    limit: 10,
    name: "",
  });
  const allUserList = useAllUserList({
    page: filterOptions.page,
    limit: filterOptions.limit,
    search: filterOptions.name,
  });
  const allSourceUserList = useAllUserList({
    page: sourceFilterOptions.page,
    limit: sourceFilterOptions.limit,
    search: sourceFilterOptions.name,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "Interview Scheduled Successfully!",
    severity: "success",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateData, setDuplicateData] = useState(null);
  const [pendingFormValues, setPendingFormValues] = useState(null);

  useEffect(() => {
    const roleType = localStorage.getItem("roleType");
    setLoginUserRole(roleType);
  }, []);

  const inputRef = useRef(null);

  const now = new Date();

  useEffect(() => {
    if (allUserList.data?.data) {
      setAllRecruiterList((prev) => [...prev, ...allUserList.data.data]);
    }
  }, [allUserList.data]);

  useEffect(() => {
    if (allSourceUserList.data?.data) {
      setAllSourceList((prev) => [...prev, ...allSourceUserList.data.data]);
    }
  }, [allSourceUserList.data]);

  const validatePhoneNumber = (phone, country) => {
    const phoneNumber = phone.slice(country.dialCode.length);
    formik.setFieldValue(
      "candidatePhone",
      "+" + country.dialCode + " " + phoneNumber,
    );
    if (phone.length === 0) {
      setPhomeErrorMessage("Phone number is required");
      return;
    }
    const isValid = isValidPhoneNumber(
      "+" + country.dialCode + " " + phoneNumber,
      country.countryCode.toUpperCase(),
    );
    if (!isValid) {
      setValidPhoneNumber(false);
      setPhomeErrorMessage("Invalid phone number");
    } else {
      setPhomeErrorMessage(null);
      setValidPhoneNumber(true);
    }
  };

  const formik = useFormik({
    initialValues: {
      candidateName: prefillData.candidateName || "",
      candidateEmail: prefillData.candidateEmail || "",
      profilePic: "",
      candidatePhone: "",
      applyFor: null,
      resume: "",
      jobDescription: "",
      startTime: null,
      endTime: null,
      street: "",
      city: "",
      state: "",
      zip: "",
      recruiter: null,
      recruiterEmail: "",
      useCustomQuestion: "",
      experienceLevel: "",
      source: "",
      interviewType: "AI Bot",
      candidateQuestions: "",
      interviewLanguage: "en",
    },
    validationSchema: Yup.object({
      candidateName: Yup.string()
        .required("Candidate Name is required")
        .max(50, "Name should not exceed 50 characters"),
      candidateEmail: Yup.string()
        .email("Invalid email address")
        .required("Email address is required"),
      useCustomQuestion: Yup.string().required("Please select Yes or No"),
      candidatePhone: Yup.string().required("Phone number is required"),
      recruiter: Yup.string()
        .required("Candidate Name is required")
        .max(50, "Name should not exceed 50 characters"),
      recruiterEmail: Yup.string()
        .email("Invalid email address")
        .required("Email address is required"),
      applyFor: Yup.object().required("Job Description is required"),
      resume: Yup.string()
        .required("Resume Title is required")
        .max(50, "Title should not exceed 50 characters"),
      jobDescription: Yup.mixed().required("Job Description is required"),
      profilePic: Yup.mixed().required("Profile Picture is required"),
      startTime: Yup.date()
        .min(new Date(), "Start Time cannot be in the past")
        .required("Start Time is required"),
    }),
    validateOnBlur: false,
    validateOnChange: onChangeValidation,
    onSubmit: (values) => {
      handleCheckEmail(values);
    },
  });

  const handleCheckEmail = (values) => {
    if (!validPhoneNumber) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Please enter a valid phone number",
      });
      return;
    }

    checkCandidateEmailMutation.mutate(
      { candidateEmail: values.candidateEmail },
      {
        onSuccess: (response) => {
          if (response.exists) {
            setDuplicateData(response.data);
            setPendingFormValues(values);
            setDuplicateModalOpen(true);
          } else {
            handleUploadResume(values);
          }
        },
        onError: () => {
          handleUploadResume(values);
        },
      },
    );
  };

  const handleConfirmSchedule = () => {
    if (pendingFormValues) {
      handleUploadResume(pendingFormValues);
    }
  };

  const handleCloseDuplicateModal = () => {
    setDuplicateModalOpen(false);
    setDuplicateData(null);
    setPendingFormValues(null);
  };

  const handleUploadResume = (values) => {
    setIsSubmitting(true);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("candidateName", values.candidateName);
    formData.append("candidateEmail", values.candidateEmail);
    formData.append("candidatePhone", values.candidatePhone);
    formData.append("applyFor", values.applyFor.role);
    formData.append("resume", values.resume);
    formData.append("jobDescription", values.jobDescription);
    formData.append("profilePic", values.profilePic);
    formData.append("recruiterEmail", values.recruiterEmail);
    formData.append("recruiter", values.recruiter);
    formData.append("startTime", values.startTime);
    formData.append("endTime", values.endTime);
    formData.append("street", values.street);
    formData.append("city", values.city);
    formData.append("state", values.state);
    formData.append("zip", values.zip);
    formData.append("useCustomQuestion", values.useCustomQuestion);
    formData.append("experienceLevel", values.experienceLevel);
    formData.append("source", values.source);
    formData.append("interviewType", values.interviewType);
    formData.append("candidateQuestions", values.candidateQuestions);
    formData.append("interviewLanguage", values.interviewLanguage || "en");
    interviewScheduleMutation.mutate(formData, {
      onSuccess: (data) => {
        handleSettingsClose();
        resetForm();
        setIsSubmitting(false);
        setUploadProgress(0);
        setDuplicateModalOpen(false);
        setDuplicateData(null);
        setPendingFormValues(null);
        setTimeout(() => {
          navigate("/app/interview/list-schedule-interview", { replace: true });
        }, 1500);
      },
      onError: (error) => {
        setIsSubmitting(false);
        setUploadProgress(0);
        setDuplicateModalOpen(false);
        setDuplicateData(null);
        setPendingFormValues(null);
        setSnackbar({
          open: true,
          severity: "error",
          message: "Failed to schedule interview. Please try again.",
        });
      },
    });
  };

  const handleGetResume = (file) => {
    formik.setFieldValue("resume", file);
  };
  const handleGetJobDescription = (file) => {
    formik.setFieldValue("jobDescription", file);
  };
  const handleSetProfilePic = (file) => {
    formik.setFieldValue("profilePic", file);
  };

  const resetForm = () => {
    setStartDate(null);
    setProfilePic("");
    formik.resetForm();
    setRecruiter(null);
    setSource(null);

    if (fileRef.current) {
      fileRef.current.value = null;
    }
    if (fileRef1.current) {
      fileRef1.current.value = null;
    }
    if (inputRef.current) {
      inputRef.current.value = null;
    }

    setClearFile(true);
    setClearProfilePic(true);
  };

  const handleSettingsClose = () => {
    setSnackbar({
      open: true,
      severity: "success",
      message: "Interview Scheduled Successfully",
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleGetMoreUserOnScroll = (event) => {
    const listboxNode = event.currentTarget;
    if (
      listboxNode.scrollTop + listboxNode.clientHeight >=
      listboxNode.scrollHeight - 50
    ) {
      if (!allUserList.isLoading) {
        setFilterOptions((prev) => ({
          ...prev,
          page: prev.page + 1,
        }));
      }
    }
  };

  useEffect(() => {
    const userData = loginUserDetail.data?.data;
    if (userData && userData.data.role !== "admin") {
      const userObj = { name: userData.data.name, email: userData.data.email };
      setRecruiter(userObj);
      formik.setFieldValue("recruiter", userData.data.name);
      formik.setFieldValue("recruiterEmail", userData.data.email);
    } else if (userData && userData.data.role === "admin") {
      setRecruiter(null);
      formik.setFieldValue("recruiter", "");
      formik.setFieldValue("recruiterEmail", "");
    }
  }, [loginUserDetail.data?.data]);

  useEffect(() => {
    if (!prefillData.job_id) return;

    const fetchJdFile = async () => {
      try {
        const jobRes = await axiosInstance.get(
          `${JobEndPoint.GET_ALL_JOBS}?search=${prefillData.job_id}&limit=1`
        );
        const job = jobRes.data.data?.[0];
        if (!job) return;

        if (prefillData.role) {
          const roles = allRoles.data?.data || [];
          const matchedRole = roles.find(
            (r) => r.role?.toLowerCase() === prefillData.role.toLowerCase()
          );
          if (matchedRole) {
            formik.setFieldValue("applyFor", matchedRole);
          }
        }

        const jdRes = await axiosInstance.get(
          `${JobEndPoint.GET_JD_FILE}/${job._id}/jd-file`,
          { responseType: "blob" }
        );
        if (jdRes.data && jdRes.data.size > 0) {
          const jdFile = new File(
            [jdRes.data],
            job.jdFileName || "job-description.pdf",
            { type: jdRes.data.type || "application/pdf" }
          );
          formik.setFieldValue("jobDescription", jdFile);
        }
      } catch (err) {
        console.error("Failed to prefill JD file", err);
      }
    };

    fetchJdFile();
  }, [prefillData.job_id, allRoles.data]);

  useEffect(() => {
    if (!prefillData.sessionId || !prefillData.candidateEmail) return;

    const fetchResume = async () => {
      try {
        const res = await axiosInstance.get(
          `${SavedCandidateEndPoint.DOWNLOAD_RESUME}?sessionId=${prefillData.sessionId}&email=${prefillData.candidateEmail}`,
          { responseType: "blob" }
        );

        const xFilename = res.headers["x-filename"];
        const filename = xFilename ? decodeURIComponent(xFilename) : "resume.pdf";

        const xPhone = res.headers["x-phone-number"];
        const phoneNumber = xPhone ? decodeURIComponent(xPhone) : "";

        if (res.data && res.data.size > 0) {
          const resumeFile = new File([res.data], filename, {
            type: res.data.type || "application/pdf",
          });
          formik.setFieldValue("resume", resumeFile);
        }

        if (phoneNumber && !formik.values.candidatePhone) {
          formik.setFieldValue("candidatePhone", phoneNumber);
          setValidPhoneNumber(true);
        }
      } catch (err) {
        console.error("Failed to prefill resume", err);
      }
    };

    fetchResume();
  }, [prefillData.sessionId, prefillData.candidateEmail]);

  const debouncedFilterChange = useCallback(
    debounce((value) => {
      setAllRecruiterList([]);
      setFilterOptions((prev) => ({
        ...prev,
        page: 1,
        name: value,
      }));
    }, 1000),
    [],
  );

  const handleInputChange = (event, value) => {
    if (!value) {
      setAllRecruiterList([]);
      setFilterOptions((prev) => ({
        ...prev,
        page: 1,
        name: "",
      }));
    } else {
      debouncedFilterChange(value);
    }
  };

  const debouncedSourceFilterChange = useCallback(
    debounce((value) => {
      setAllSourceList([]);
      setSourceFilterOptions((prev) => ({
        ...prev,
        page: 1,
        name: value,
      }));
    }, 1000),
    [],
  );

  const handleSourceInputChange = (event, value) => {
    if (!value) {
      setAllSourceList([]);
      setSourceFilterOptions((prev) => ({
        ...prev,
        page: 1,
        name: "",
      }));
    } else {
      debouncedSourceFilterChange(value);
    }
  };

  const handleGetMoreSourceOnScroll = (event) => {
    const listboxNode = event.currentTarget;
    if (
      listboxNode.scrollTop + listboxNode.clientHeight >=
      listboxNode.scrollHeight - 50
    ) {
      if (!allSourceUserList.isLoading) {
        setSourceFilterOptions((prev) => ({
          ...prev,
          page: prev.page + 1,
        }));
      }
    }
  };

  const levelOptions = [
    { value: "Junior", label: "Junior" },
    { value: "Middle", label: "Middle" },
    { value: "Senior", label: "Senior" },
    { value: "Leadership", label: "Leadership" },
  ];

  const languageOptions = LANGUAGE_OPTIONS;

  const interviewTypeOptions = [
    { value: "AI Bot", label: "AI Interview" },
    { value: "Coding Test", label: "Coding Assessment" },
    { value: "AI Bot +", label: "AI Bot +" },
  ];

  return {
    profilePic,
    allRoles,
    startDate,
    clearFile,
    fileRef,
    fileRef1,
    clearProfilePic,
    phomeErrorMessage,
    loginUserRoles,
    recruiter,
    allUserList,
    snackbar,
    isSubmitting,
    inputRef,
    now,
    allRecruiterList,
    formik,
    duplicateModalOpen,
    duplicateData,
    levelOptions,
    languageOptions,
    interviewTypeOptions,

    setStartDate,
    setSnackbar,
    setProfilePic,
    setRecruiter,
    source,
    setSource,
    allSourceList,
    allSourceUserList,
    handleSourceInputChange,
    handleGetMoreSourceOnScroll,
    setFilterOptions,
    setOnChangeValidation,
    handleInputChange,
    validatePhoneNumber,
    handleGetMoreUserOnScroll,
    handleCloseSnackbar,
    handleSetProfilePic,
    handleGetJobDescription,
    handleGetResume,
    handleConfirmSchedule,
    handleCloseDuplicateModal,
  };
};

export default useInterviewScheduling;
